import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Add, Close, NotificationAdd } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import SelectMultipleCompanyEmployee from "../Quotes/QuoteForm/SelectMultipleCompanyEmployees";

const SendPickupAvailableNotificationDialog = ({
  orderId,
  open,
  handleClose,
}) => {
  const [order, setOrder] = useState(null);
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [finalizeQuoteEmailReceivers, setFinalizeQuoteEmailReceivers] =
    useState([]);
  const [sendQuoteCopyTo, setSendQuoteCopyTo] = useState([]);
  const [isAddingOtherApproversToCopy, setIsAddingOtherApproversToCopy] =
    useState(false);

  // This is admin only
  const getOrder = async (orderId) => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/admin/orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setOrder(response.data.order);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  const sendNotification = async (orderId, sendQuoteCopyTo) => {
    try {
      setLoading(true);
      const response = await ezorder.post(
        `/shop/jobs/${orderId}/pickup-history/send-notification`,
        { sendTo: sendQuoteCopyTo },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      // setOrder(response.data.order);
      handleClose();
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(order);
    if (order && order.estimateRequestedBy) {
      setSendQuoteCopyTo([order.estimateRequestedBy]);
    }
  }, [order]);

  useEffect(() => {
    getOrder(orderId);
  }, [orderId]);

  if (order)
    return (
      <Dialog
        fullWidth
        open={open}
        onClose={() => {
          handleClose();
        }}
      >
        <DialogTitle>Send Pickup Available Notification</DialogTitle>
        <DialogContent>
          <Box sx={{ paddingTop: "8px" }}>
            <SelectMultipleCompanyEmployee
              required
              disabled={!order.company}
              companyId={order.company ? order.company.id : null}
              value={sendQuoteCopyTo}
              onUpdate={(users) => {
                setSendQuoteCopyTo(users);
              }}
              label="Send To"
              enableAdd={true}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              sendNotification(orderId, sendQuoteCopyTo);
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    );
};

export default SendPickupAvailableNotificationDialog;
